import {useCallback, useEffect, useMemo, useState} from "react";
import AuthUtil from "@/utils/AuthUtil";
import {defaultAvatar} from "@/api/commonApi.js";
import {useSetState} from "ahooks";
import * as Api from "@/api/api.js";

const useUserState = () => {
    const [token, setToken] = useState("")
    const isLogin = useMemo(() => {
        return !!token;
    }, [token])

    const [userInfo, setUserInfo] = useSetState({
        id: 0,
        username: "",
        avatar: defaultAvatar,
        nickname: "",
        gender: undefined,
        birthday: 0,
        roleList: []
    })

    const loadData = () => {
        setToken(AuthUtil.getToken() || "")
        updateUserInfo(AuthUtil.getUserInfo())
    }

    const fetchInfo = async () => {
        await Api.userInfo()
        loadData();
    }

    const updateUserInfo = (value) => {
        if (!value) {
            return;
        }

        const innerValue = {
            ...value,
        }

        if (!innerValue.avatar) {
            innerValue.avatar = defaultAvatar
        }
        if (!innerValue.roleList) {
            innerValue.roleList = []
        }

        setUserInfo(innerValue)
    }


    useEffect(() => {
        loadData()
    }, [])

    return {
        token,
        userInfo,
        fetchInfo,
        isLogin
    }
}

export default useUserState